exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".practice-team--3f_QB99N1i1xaQtasxMGo0 {\n  display: flex;\n  flex-direction: column;\n}\n\n.practice-team--EOKmpEOmrAfb9Mzkt-Mtm {\n  display: flex;\n  flex-direction: column;\n  max-width: 300px;\n}\n\n.practice-team--EOKmpEOmrAfb9Mzkt-Mtm .buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  margin: 1rem 0 0 0;\n}\n", ""]);

// exports
exports.locals = {
	"practiceTeamFormContainer": "practice-team--3f_QB99N1i1xaQtasxMGo0",
	"practiceTeamFormContainer": "practice-team--3f_QB99N1i1xaQtasxMGo0",
	"practiceTeamFormContainerInner": "practice-team--EOKmpEOmrAfb9Mzkt-Mtm",
	"practiceTeamFormContainerInner": "practice-team--EOKmpEOmrAfb9Mzkt-Mtm"
};